export default "__VITE_ASSET__BjK2fk3s__"